import { Box, Center, Spinner } from '@chakra-ui/react';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';
import { useFetchFullEventTypesQuery } from 'rtkQuery/sharespro/queries/events';

const EventCategoriesContainer: FC = () => {
  const { t } = useTranslation();

  const { data, isFetching, error, refetch } = useFetchFullEventTypesQuery();

  const wrapByCard = !data;
  let content;
  if (data) {
    content = (
      <>
        {data.items.map((category, index) => {
          if (category.events.length === 0) {
            return null;
          }

          return (
            <Box key={index} mb="20px">
              <GridHeading
                trailingLink={{
                  text: t('allItems'),
                  path: AppRoute.events(category.id),
                }}
              >
                {category.name}
              </GridHeading>
              <EventGridCarousel events={category.events} maxWidth="992px" />
            </Box>
          );
        })}
      </>
    );
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20px" h="230px">
        <Center h="100%">{content}</Center>
      </AppCard>
    );
  }

  return content;
};

export default EventCategoriesContainer;
